import React, { Component } from 'react'
import { connect } from "react-redux"
import { AxiosResponse } from "axios";
import { ID } from '@bdfx/mergado-ui-kit/lib/helpers/types';

import trans from "trans";

import ShapeList from "shape-list/components/shape-list"
import ShapeSelection from "../components/shape-selection"

import { getShapeSets } from "app/helpers/api";
import { setShapeSetsToStore, createToast, setEditMode } from "actions"

import EditEffects from "template-edit/components/edit-effects"

import QueriesForm from "template-edit/forms/queries-form";
import SaveTemplateForm from "template-edit/components/save-template-form";

import { sortBy, forEach, find } from "lodash";

import {
    css,
    GridCell,
    Div,
    Button,
    Grid,
    Message,
    Theme,
    Icon,
    Toggler,
    FieldLabel,
} from "@bdfx/mergado-ui-kit"

import { ESCAPE_KEY } from "app/helpers/keymap";

import {
    LAYER_COPIED,
} from "template-edit/reducers";

import {
    updateInputValue as change,
    initForm,
    selectFormValues
} from "app/reducers/form";

import {
    ACTIVE_VIEW_AI_ELEMENTS, ACTIVE_VIEW_EDIT_AUTO_ON_OFF, ACTIVE_VIEW_EDIT_EFFECTS, ACTIVE_VIEW_EDIT_QUERIES, ACTIVE_VIEW_EDIT_SHAPE,
    ACTIVE_VIEW_EDIT_SOURCE_IMAGE, ACTIVE_VIEW_NEW_SHAPE, ACTIVE_VIEW_SHAPE_SELECTION, ACTIVE_VIEW_TEMPLATE_GALLERY, ActiveViewType, UpdateEffectsFunctionType
} from "template-edit/containers/Editor";

import { nextIndex, prevIndex, redoHistory, TemplateOrAlternativeTemplateType, undoHistory, UndoRedoHistory } from "template-edit/undoRedoReducers";
import { setActiveShapeId, setActiveGroupId, setActiveView } from "../reducers";

import Shape, { BADGE_TYPE, BITMAP_TYPE, CUSTOM_SET_TYPE, DYNAMIC_TEXT_TYPE, EXTERNAL_IMAGE_SOURCE_TYPE, RATING_TYPE, SOURCE_IMAGE_TYPE } from "shape-entities/types/shape";

import uniqueId from "app/helpers/unique_id";
import toastFactory, { ResponseErrorType } from "app/helpers/toast_factory";
import TabsPanel from "template-edit/components/tabs-panel";
import CommonShapeForm, { StyledSeparatorNoLine } from "../forms/common-shape-form";
import { calculateGroupSizeAndPosition, createGroupFromSelected, getFormName, getTemplateSize, reorderShapes, SOURCE_IMAGE_INDEX } from "../forms/helpers";
import { selectLayers } from "shape-list/reducers";
import { Project, ShapeSet } from "app/types/model-types"
import TemplateGallery from "template-edit/components/template-gallery"
import EditAutoOnoff from "template-edit/components/edit-auto-onoff"
import EditFormat from "template-edit/components/edit-format"
import { Gradient } from "app/types/model-types";
import { RandomProduct } from 'shape-edit/types'
import { DEFAULT_ASPECT_RATIO_TYPES, defaultFontName, isPointShapeType, isTextShapeType } from "shape-entities/defaults";
import { IconAddLayer, IconAIParams, IconLayers, IconLightBulb } from 'app/icons';
import VisualSimilarity from 'template-edit/components/visual-similarity';
import SourceImageLayoutForm from 'shape-edit/forms/source-image-layout-form';
import ClipMaskForm from 'shape-edit/forms/clip-mask-form';
import { ImagickFontsReduxList } from 'app/reducers/imagickFontsReduxList';
import ShapeSpecificFormBefore from '../forms/shape-specific-form-before';
import ShapeSpecificFormAfter from '../forms/shape-specific-form-after';
import { getLangPrefixFromOutputFormat } from 'trans/helpers';
import { EditModeType } from 'app/types/app-types';
import { iconDisabledColor, iconSize } from 'template-edit/components/tools-panel';
import { getIconByType } from 'shape-list/components/shape-list-item';
import PreferredRandomProduct from 'template-edit/components/preferred-random-product';
import EnlargeByAndOverscan from 'template-edit/components/enlarge-by-and-overscan';
import SourceImagePositionAndRotationForm from 'shape-edit/forms/source-image-position-and-rotation-form';


interface Props {
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    imagickFonts: ImagickFontsReduxList
    project: Project
    activeView: ActiveViewType
    editMode: EditModeType
    randomProduct: RandomProduct
    activeShapeId: string
    activeGroupId: string
    selectedLayers: string[]
    shapeSets: ShapeSet[],
    gradients: Gradient[]
    setShapeSetsToStore: Function
    undoHistory: Function
    redoHistory: Function
    undoRedoHistory: UndoRedoHistory
    initForm: typeof initForm
    change: typeof change
    setActiveView: typeof setActiveView
    setEditMode: typeof setEditMode
    setActiveShapeId: typeof setActiveShapeId
    setActiveGroupId: typeof setActiveGroupId
    createToast: typeof createToast
    selectLayers: typeof selectLayers
    mouseOverShape: string
    setMouseOverShape: Function
    updateEffects: UpdateEffectsFunctionType
    showOverlap: boolean
    showAsModal: boolean
    setShowOverlap: Function
    handleImageRefresh: Function
    setShowAsModal: Function
}

interface State {
    checkIsValid: boolean
    shapeClipboard: Shape[]
    aspectSizeRatio: boolean
}

let singleClickTimer

export type RenderCellsType = {
    isEnabled: boolean
    title: string
    activeView: ActiveViewType
    button: JSX.Element
}

export type StepType = {
    isEnabled: boolean
    activeView: ActiveViewType
    content: JSX.Element
}

class RightPanel extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            checkIsValid: false,
            shapeClipboard: null,
            aspectSizeRatio: null,
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        const { activeView, form } = this.props

        if (prevProps && prevProps.activeView !== activeView && activeView !== ACTIVE_VIEW_EDIT_SHAPE) {
            this.setState({ checkIsValid: true })
            const shapes = form.shapes

            if (shapes) {
                let newShapes = [];
                const orderedShapes = sortBy(Object.keys(shapes).map(shapeIndex => shapes[shapeIndex]), [shape => new Number(shape.priority)])
                orderedShapes.forEach((shape) => {
                    const pushShape = { ...shape, priority: shape.priority + 1 }
                    const isPointType = isPointShapeType(shape.type)
                    if (!
                        (
                            (shape.type === BITMAP_TYPE && (!shape.image_file_id && !shape.imageBlob)) ||
                            (shape.type === DYNAMIC_TEXT_TYPE && !shape.text_xml_element) ||
                            (shape.type === RATING_TYPE && !(shape.rating_xml_element || shape.rating_from_depots)) ||    //rating without element specified
                            /* (shape.type === IMAGE_FROM_ELEMENTS_TYPE && !shape.image_xml_element) || */
                            (shape.type === BADGE_TYPE && !shape.set_file_id) ||
                            (shape.type === CUSTOM_SET_TYPE && !shape.custom_set_file_id) ||
                            (shape.type === EXTERNAL_IMAGE_SOURCE_TYPE && !shape.custom_set_file_id) ||
                            (isPointType && (!shape.points || (Array.isArray(shape.points) && shape.points.length < 1)))
                        )
                    ) {
                        newShapes[shape.index] = pushShape
                    }
                })

                reorderShapes({ ...newShapes }, Object.keys(newShapes))
            }
        }
    }

    componentDidMount() {
        const { activeShapeId, imagickFonts, form, isAlt } = this.props

        const formName = getFormName(isAlt)

        const { shapes } = form

        getShapeSets()
            .then((response: AxiosResponse<any>) => {
                this.props.setShapeSetsToStore(response.data)
            })
            .catch(error => {
                console.error('error while loading shape sets', error)
            })

        document.addEventListener("keydown", this.handleKeyDown)

        let clickCount = 0
        document.querySelectorAll('input').forEach(function (element: HTMLInputElement) {
            if (element) {
                if (!(
                    element.parentNode &&
                    element.parentNode.parentNode &&
                    element.parentNode.parentNode.parentElement &&
                    element.parentNode.parentNode.parentElement.classList.contains('exclude-click')
                ))
                    element.onclick = function () {
                        clickCount++

                        if (clickCount === 1) {
                            singleClickTimer = setTimeout(function () {
                                clickCount = 0;
                                //console.log('this is single click')
                            }, 400);
                        } else if (clickCount === 2) {
                            clearTimeout(singleClickTimer);
                            clickCount = 0;
                            element.select()
                            //console.log('double click, selecting', singleClickTimer)
                        }
                    }
            }
        });

        if (activeShapeId && !(shapes || shapes[activeShapeId])) {
            this.props.setActiveView(form.is_keep_size ? ACTIVE_VIEW_TEMPLATE_GALLERY : ACTIVE_VIEW_SHAPE_SELECTION)
            this.props.setActiveShapeId(null)
        }

        if (activeShapeId && shapes[activeShapeId]) {
            this.setState({ aspectSizeRatio: shapes[activeShapeId].is_aspect_size_ratio || DEFAULT_ASPECT_RATIO_TYPES.includes(shapes[activeShapeId].type) })     //shouldAspectRatio = (type: string) : boolean

            const shapeSubFormName = `shapes.${activeShapeId}`

            const shape: Shape = {
                ...shapes[activeShapeId],
                text_fontfamily: shapes[activeShapeId].text_fontfamily ?? defaultFontName
            }

            //start uploading image file on bitmapForm loaded
            if (shape && shape.type === BITMAP_TYPE && !shape.imageBlob) {
                const el = document.getElementById(`file_upload_${shape.index}`)
                if (el) {
                    el.click()
                }
            }

            //no font name defined or it is not available
            if (imagickFonts.isLoaded && shape.text_fontfamily) {
                const currentFont = find(imagickFonts.data.fontsMap, (fontItem) => {
                    return fontItem.text_fontfamily === shape.text_fontfamily
                })

                if (!currentFont) {
                    const error: ResponseErrorType = {
                        message: '',
                        response: {
                            status: 404,
                            data: { message: shape.text_fontfamily + ' : ' + trans('font_not_found') },
                            headers: {},
                            statusText: '',
                        }
                    }

                    console.error('cannot find font', shape.text_fontfamily, error)
                    this.props.change(formName, `${shapeSubFormName}.text_fontfamily`, defaultFontName)
                }
            }

            if (!shapes[activeShapeId].text_fontfamily && isTextShapeType(shapes[activeShapeId].type)) {
                this.props.change(formName, `${shapeSubFormName}.text_fontfamily`, defaultFontName)
            }
        }
    }

    handleKeyDown = (event) => {
        const { form, isAlt, activeShapeId, activeView, selectedLayers } = this.props
        const { shapeClipboard } = this.state

        const formName = getFormName(isAlt)

        //do not prevent default for
        if (event.target.type || ['TEXTAREA', 'INPUT'].includes(event.target.tagName)) {
            return;
        }

        if (event.ctrlKey) {
            const { undoRedoHistory } = this.props
            const isFocused = [ACTIVE_VIEW_EDIT_SHAPE, ACTIVE_VIEW_SHAPE_SELECTION].includes(activeView)  //todo: mouse within area + active view edit-shape or shapes list

            const nextIdx = nextIndex(undoRedoHistory.index)
            const prevIdx = prevIndex(undoRedoHistory.index)

            const nextData = undoRedoHistory.buffer[nextIdx]
            const prevData = undoRedoHistory.buffer[prevIdx]

            switch (event.key) {
                case 'z':   //undo
                case 'Z':
                    event.preventDefault()

                    if (!!prevData) {
                        this.props.undoHistory()
                        this.props.initForm(formName, prevData)
                    }
                    break;
                case 'y':   //redo
                case 'Y':
                    event.preventDefault()

                    if (!!nextData) {
                        this.props.redoHistory()
                        this.props.initForm(formName, nextData)
                    }
                    break;
                case 'c': //copy
                case 'C':
                    if (!activeShapeId && selectedLayers.length < 1) {
                        break
                    }
                    if (activeShapeId && isFocused) {
                        event.preventDefault()
                        const shapeToCopy: Shape = {
                            ...form.shapes[activeShapeId],
                            id: null,
                            index: null,
                            priority: 0,
                            x: form.shapes[activeShapeId].x + 10,
                            y: form.shapes[activeShapeId].y + 10,
                        }
                        this.setState({ shapeClipboard: [shapeToCopy] })
                        this.props.createToast(toastFactory(LAYER_COPIED))
                    } else if (isFocused && selectedLayers.length > 0) {
                        event.preventDefault()

                        const orderedByPriority = sortBy(form.shapes, [(shape) => {
                            return shape.priority
                        }]).filter(shape => (selectedLayers.includes(shape.index)))

                        const sizeAndPosition = calculateGroupSizeAndPosition()
                        const oldShapeIndexes = orderedByPriority.map(shape => shape.index)

                        let newShapes = []
                        oldShapeIndexes.forEach((index) => {
                            newShapes.push({
                                ...form.shapes[index],
                                id: null,
                                index: null,
                                priority: 0,
                                x: .5 * form.size.width + form.shapes[index].x - sizeAndPosition.middleX,
                                y: .5 * form.size.height + form.shapes[index].y - sizeAndPosition.middleY,
                            })
                        })

                        this.setState({ shapeClipboard: newShapes })
                        this.props.createToast(toastFactory(LAYER_COPIED))
                    }

                    break;
                case 'v': //paste
                case 'V':
                    if (shapeClipboard && shapeClipboard.length > 0 && isFocused) {
                        let newIndexes = []
                        let newShapes = []
                        const alterPosition = activeShapeId && shapeClipboard.length === 1
                        shapeClipboard.forEach(newShape => {
                            const newShapeIndex = uniqueId()
                            newShapes[newShapeIndex] = {
                                ...newShape,
                                index: newShapeIndex,
                                x: alterPosition ? form.shapes[activeShapeId].x + 10 : newShape.x,
                                y: alterPosition ? form.shapes[activeShapeId].y + 10 : newShape.y,
                            }
                            newIndexes.push(newShapeIndex)
                        })

                        let allIndexOrder = []
                        allIndexOrder.push(...newIndexes)
                        forEach(form.shapes, (shape) => {
                            allIndexOrder.push(shape.index)
                        })

                        //console.debug('before', Object.keys(form.shapes).map(idx => `${form.shapes[idx].priority}: ${form.shapes[idx].index} (${form.shapes[idx].type})`))
                        //console.debug('new indexes order', allIndexOrder)

                        reorderShapes({ ...newShapes, ...form.shapes }, allIndexOrder)

                        this.props.setActiveView(ACTIVE_VIEW_SHAPE_SELECTION)

                        //set active
                        if (shapeClipboard.length === 1) {
                            this.props.setActiveShapeId(newIndexes[0])
                        } else {
                            //add new shape indexes to selection:
                            this.props.selectLayers(newIndexes)
                            createGroupFromSelected()
                        }
                    }
                    break
                default:
                    //console.debug('ctrl + other key', event)
                    break;
            }
        } else {
            switch (event.keyCode) {
                case ESCAPE_KEY:
                    event.preventDefault()
                    this.unselectShape()
                    break;
                default:
                    //console.debug('other key', event)
                    break;
            }
        }
    }

    componentWillUnmount(): void {
        document.removeEventListener("keydown", this.handleKeyDown)

        if (singleClickTimer) {
            clearTimeout(singleClickTimer)
        }
    }

    unselectShape = () => {
        this.props.setActiveShapeId(null)
        this.props.setActiveView(ACTIVE_VIEW_EDIT_SOURCE_IMAGE)
        console.debug(`unselectShape: setEditMode ${this.props.editMode} --> oposite`)
        if (this.props.editMode === 'text') {  //switch back
            this.props.setEditMode('select')
        } else {
            this.props.setEditMode('text')
        }

    }

    handleAddShape = () => {
        this.props.setActiveView(ACTIVE_VIEW_NEW_SHAPE)
    }

    updateTemplateFieldValue = (templateId: ID, updateValues: object) => {
        const { form, isAlt } = this.props

        const formName = getFormName(isAlt)
        this.props.initForm(formName, {
            ...form,
            ...updateValues,
        })
    }


    getSteps = (enabledCells: RenderCellsType[]): StepType[] => {
        const { checkIsValid } = this.state
        const { form, isAlt, randomProduct, activeShapeId, activeView, project } = this.props

        const formName = getFormName(isAlt)
        const templateSize = getTemplateSize(form)

        const outputLangPrefix = getLangPrefixFromOutputFormat(project.output_format)
        const stepByActiveView = enabledCells.findIndex(cell => cell.activeView === activeView) + 1

        return [
            {
                isEnabled: true,
                activeView: ACTIVE_VIEW_EDIT_QUERIES,
                content: <React.Fragment>
                    <GridCell className="step">{stepByActiveView}.</GridCell>
                    <GridCell className="title">{trans("select_template_queries")}</GridCell>
                    <GridCell className="content" col={"1 / -1"}>
                        <QueriesForm checkIsValid={checkIsValid} /></GridCell>
                </React.Fragment>,
            },
            {
                isEnabled: true,
                activeView: ACTIVE_VIEW_TEMPLATE_GALLERY,
                content: <React.Fragment>
                    <GridCell className="step">{stepByActiveView}.a</GridCell>
                    <GridCell className="title">{trans("set_output_image_size")}</GridCell>
                    <GridCell className="content" col={"1 / -1"}>
                        <EditFormat />
                    </GridCell>

                    <GridCell className="step">{stepByActiveView}.b</GridCell>
                    <GridCell className="title">{trans(!isAlt && form.is_collage ? (form.is_anim_gif ? "set_anim_gif" : "set_collage_layout") : "main_image_on_canvas_placement")}</GridCell>
                    <GridCell className="content" col={"1 / -1"}>
                        <PreferredRandomProduct
                            handleImageRefresh={this.props.handleImageRefresh}
                        />

                        {!form.is_collage &&
                            <EnlargeByAndOverscan
                                updateEffects={this.props.updateEffects}
                                showOverlap={this.props.showOverlap}
                                setShowOverlap={this.props.setShowOverlap}
                            />
                        }

                        <SourceImagePositionAndRotationForm />
                    </GridCell>
                </React.Fragment>,
            },
            {
                isEnabled: true,
                activeView: ACTIVE_VIEW_EDIT_SOURCE_IMAGE,
                content: <React.Fragment>
                    <SourceImageLayoutForm
                        handleImageRefresh={this.props.handleImageRefresh}
                        showOverlap={this.props.showOverlap}
                        setShowOverlap={this.props.setShowOverlap}
                    />

                    {form.shapes[SOURCE_IMAGE_INDEX]?.clip_mask &&
                        <GridCell col={'1/-1'}>
                            <ClipMaskForm shape={form.shapes[SOURCE_IMAGE_INDEX]} onlyMask={false} />
                        </GridCell>
                    }

                    {(!form.is_keep_size) &&
                        <React.Fragment>
                            <GridCell className="step">{stepByActiveView}.b</GridCell>
                            <GridCell className="title">{trans("select_from_template_gallery")}</GridCell>
                            <GridCell className="content" col={"1 / -1"}>
                                {(!form.is_keep_size && form.size_id) ?
                                    <TemplateGallery sizeRatio={templateSize.width / templateSize.height} /> :
                                    <Message
                                        type="warning"
                                        closeable={false}
                                        icon={<IconLightBulb size={24} />}
                                        style={{ borderColor: '#e0bf00' }}
                                    >
                                        {trans('select_format_to_see_templates')}
                                    </Message>
                                }
                            </GridCell>
                        </React.Fragment>
                    }
                </React.Fragment>,
            },
            {
                isEnabled: true,
                activeView: ACTIVE_VIEW_EDIT_EFFECTS,
                content: <React.Fragment>
                    <GridCell className="step">{stepByActiveView}.</GridCell>
                    <GridCell className="title">{trans("apply_ai_effects_or_filters")}</GridCell>
                    <GridCell className="content" col={"1 / -1"}>
                        <EditEffects
                            updateEffects={this.props.updateEffects}
                            setShowAsModal={this.props.setShowAsModal}
                            showAsModal={this.props.showAsModal}
                            updateTemplateFieldValue={this.updateTemplateFieldValue}
                        />
                    </GridCell>
                </React.Fragment>,
            },
            {
                isEnabled: true,
                activeView: ACTIVE_VIEW_EDIT_AUTO_ON_OFF,
                content: <React.Fragment>
                    <GridCell className="step">{stepByActiveView}.</GridCell>
                    <GridCell className="title">{trans("editor_step_5")}</GridCell>
                    <GridCell className="content" col={"1 / -1"}><EditAutoOnoff /></GridCell>
                </React.Fragment>,
            },
            {
                isEnabled: !form.is_keep_size,
                activeView: ACTIVE_VIEW_SHAPE_SELECTION,
                content: <React.Fragment>
                    <GridCell className="step">{stepByActiveView}.</GridCell>
                    <GridCell className="title">
                        {trans("editor_step_7")}

                        {!form.is_keep_size &&
                            <Button icon="plus-light"
                                simple={true} size={"tiny"}
                                color="white"
                                onClick={(e) => this.handleAddShape()}
                                style={{ float: "right", lineHeight: "18px !important" }} />
                        }
                    </GridCell>
                    <GridCell className="content" col={"1 / -1"}>
                        <ShapeList
                            mouseOverShape={this.props.mouseOverShape}
                            setMouseOverShape={this.props.setMouseOverShape}
                        />
                    </GridCell>
                </React.Fragment>,
            },
            {
                isEnabled: true,
                activeView: ACTIVE_VIEW_EDIT_SHAPE,
                content: <GridCell col={'1/-1'}>
                    {(activeShapeId && typeof form.shapes[activeShapeId] !== 'undefined') ?
                        <React.Fragment>
                            <ShapeSpecificFormBefore
                                formName={formName}
                                shape={form.shapes[activeShapeId]}
                                change={this.props.change}
                                shapes={form.shapes}
                                templateSize={templateSize}
                                activeShapeId={activeShapeId}
                                setActiveShapeId={this.props.setActiveShapeId}
                            />

                            <CommonShapeForm />

                            <ShapeSpecificFormAfter
                                form={form}
                                formName={formName}
                                shape={form.shapes[activeShapeId]}
                                change={this.props.change}
                            />

                            {form.shapes[activeShapeId]?.clip_mask &&
                                <ClipMaskForm shape={form.shapes[activeShapeId]} onlyMask={false} />
                            }
                        </React.Fragment> :
                        <Grid cols="auto 1fr" gap="10px">
                            <GridCell className="step">{stepByActiveView}.</GridCell>
                            <GridCell className="title">{trans("position_and_rotation")}</GridCell>
                            <GridCell className="content" col={"1 / -1"}>
                                <SourceImagePositionAndRotationForm />
                            </GridCell>
                        </Grid>
                    }

                </GridCell>,
            },
            {
                isEnabled: true,
                activeView: ACTIVE_VIEW_NEW_SHAPE,
                content: <GridCell col={'1/-1'}>
                    <ShapeSelection />
                </GridCell>,
            },
            {
                isEnabled: !isAlt,
                activeView: ACTIVE_VIEW_AI_ELEMENTS,
                content: <React.Fragment>
                    <GridCell className="step">{stepByActiveView}.</GridCell>
                    <GridCell className="title">{trans('ai_elements_to_feed')}</GridCell>
                    <GridCell className="content" col={"1 / -1"}>
                        {!isAlt &&
                            <React.Fragment>
                                <div>
                                    <FieldLabel style={{ marginBottom: '10px' }}>{trans('ai_params')}</FieldLabel>
                                    <Toggler
                                        value={form.ai_params_enabled}
                                        onLabel={trans('ai_params_generate')}
                                        title={trans('ai_params_generate')}
                                        onChange={(newValue) => {
                                            this.updateTemplateFieldValue(form.id, {
                                                ai_params_enabled: newValue,
                                            })
                                        }}
                                    />

                                    {!!form.ai_params_enabled && <Message>{trans("ai_params_is_running_on_background")}</Message>}
                                </div>

                                <div style={{ marginTop: '22px' }}>
                                    <FieldLabel style={{ marginBottom: '10px' }}>{trans('visual_similarity')}</FieldLabel>
                                    <VisualSimilarity
                                        templateId={form.id}
                                        product={randomProduct}
                                        enabled={form.visual_similarity_enabled}
                                        n={form.visual_similarity_n}
                                        threshold={form.visual_similarity_threshold}
                                        templateids={form.visual_similarity_templateids}
                                        updateTemplateFieldValue={this.updateTemplateFieldValue}
                                        publishAutomatically={true}
                                    />
                                </div>
                            </React.Fragment>
                        }
                    </GridCell>
                </React.Fragment>,
            },
        ]
    }


    getEnabledCells = () : RenderCellsType[] => {
        const { isAlt, activeView, form, activeShapeId } = this.props
        const shape = activeShapeId && form && form.shapes ? form.shapes[activeShapeId] : null

        let renderCells: RenderCellsType[] = [
            {
                isEnabled: !isAlt,
                title: trans('nav_queries'),
                activeView: ACTIVE_VIEW_EDIT_QUERIES,
                button: <Button
                    color="nocolor"
                    size="tiny"
                    className={activeView === ACTIVE_VIEW_EDIT_QUERIES ? 'active' : 'not-active'}
                    icon={<Icon type={'box-light'} size={iconSize} color={activeView === ACTIVE_VIEW_EDIT_QUERIES ? Theme.blue : iconDisabledColor} />}
                    onClick={() => this.props.setActiveView(ACTIVE_VIEW_EDIT_QUERIES)}
                />,
            },
            {
                isEnabled: true,
                title: trans('template_sizes'),
                activeView: ACTIVE_VIEW_TEMPLATE_GALLERY,
                button: <Button
                    color="nocolor"
                    size="tiny"
                    className={activeView === ACTIVE_VIEW_TEMPLATE_GALLERY ? 'active' : 'not-active'}
                    icon={<Icon type={'maximise-light'} size={iconSize} color={activeView === ACTIVE_VIEW_TEMPLATE_GALLERY ? Theme.blue : iconDisabledColor} />}
                    onClick={() => this.props.setActiveView(ACTIVE_VIEW_TEMPLATE_GALLERY)}
                />,
            },
            {
                isEnabled: true,
                title: trans('layout'),
                activeView: ACTIVE_VIEW_EDIT_SOURCE_IMAGE,
                button: <Button
                    color="nocolor"
                    size="tiny"
                    className={activeView === ACTIVE_VIEW_EDIT_SOURCE_IMAGE ? 'active' : 'not-active'}
                    icon={<Icon type={'layout-left-light'} size={iconSize} color={activeView === ACTIVE_VIEW_EDIT_SOURCE_IMAGE ? Theme.blue : iconDisabledColor} />}
                    onClick={() => {
                        this.props.setActiveShapeId(null)
                        this.props.setActiveView(ACTIVE_VIEW_EDIT_SOURCE_IMAGE)
                    }}
                />,
            },
            {
                isEnabled: true,
                title: trans('group_effects') + ' & ' + trans('background_settings').toLowerCase(),
                activeView: ACTIVE_VIEW_EDIT_EFFECTS,
                button: <Button
                    color="nocolor"
                    size="tiny"
                    icon={<Icon type={'magic'} size={iconSize} color={activeView === ACTIVE_VIEW_EDIT_EFFECTS ? Theme.blue : iconDisabledColor} />}
                    onClick={() => this.props.setActiveView(ACTIVE_VIEW_EDIT_EFFECTS)}
                />,
            },
            {
                isEnabled: !form.is_keep_size,
                title: trans('nav_shapes'),
                activeView: ACTIVE_VIEW_SHAPE_SELECTION,
                button: <Button
                    color="nocolor"
                    size="tiny"
                    icon={<IconLayers size={24} color={activeView === ACTIVE_VIEW_SHAPE_SELECTION ? Theme.blue : iconDisabledColor} />}
                    onClick={() => this.props.setActiveView(ACTIVE_VIEW_SHAPE_SELECTION)}
                />,
            },
            {
                isEnabled: activeView === ACTIVE_VIEW_NEW_SHAPE,
                title: trans('add_shape_button'),
                activeView: ACTIVE_VIEW_NEW_SHAPE,
                button:
                    <Button
                        color="nocolor"
                        size="tiny"
                        icon={<IconAddLayer size={iconSize} color={Theme.blue} />}
                        onClick={() => this.props.setActiveView(ACTIVE_VIEW_NEW_SHAPE)}
                    />
            },
            {
                isEnabled: activeShapeId && activeShapeId !== SOURCE_IMAGE_INDEX,
                activeView: null,
                title: shape ? `${trans(shape.type)} ${shape.name}` : trans(SOURCE_IMAGE_TYPE),
                button: <Button
                    color="nocolor"
                    size="tiny"
                    icon={getIconByType(shape ? shape.type : SOURCE_IMAGE_TYPE, iconSize, activeView === ACTIVE_VIEW_EDIT_SHAPE ? Theme.blue : iconDisabledColor)}
                    onClick={() => this.props.setActiveView(ACTIVE_VIEW_EDIT_SHAPE)}
                />
            },
            {
                isEnabled: !isAlt,
                title: trans('ai_elements_to_feed'),
                activeView: ACTIVE_VIEW_AI_ELEMENTS,
                button: <Button
                    color="nocolor"
                    size="tiny"
                    icon={<IconAIParams size={24} color={activeView === ACTIVE_VIEW_AI_ELEMENTS ? Theme.blue : iconDisabledColor} />}
                    onClick={() => this.props.setActiveView(ACTIVE_VIEW_AI_ELEMENTS)}
                />,
            },
            {
                isEnabled: !isAlt,
                title: trans('autoonoff'),
                activeView: ACTIVE_VIEW_EDIT_AUTO_ON_OFF,
                button: <Button
                    color="nocolor"
                    size="tiny"
                    icon={<Icon type={'time-light'} size={iconSize} color={activeView === ACTIVE_VIEW_EDIT_AUTO_ON_OFF ? Theme.blue : iconDisabledColor} />}
                    onClick={() => this.props.setActiveView(ACTIVE_VIEW_EDIT_AUTO_ON_OFF)}
                />,
            },
        ]

        return renderCells.filter(c => c.isEnabled)
    }

    render() {
        const { activeView, form, isAlt, randomProduct, activeShapeId, project } = this.props
        const { checkIsValid } = this.state

        const enabledCells = this.getEnabledCells()
        const filteredSteps = this.getSteps(enabledCells).filter(step => step.isEnabled && (!step.activeView || step.activeView === activeView))

        return (
            <>
                <TabsGridCell id={'right-tabs'}>
                    <TabsPanel
                        activeView={activeView}
                        enabledCells={enabledCells}
                    />
                </TabsGridCell>

                <PanelGridCell id={'right-panel'}>
                    <SaveTemplateForm updateEffects={this.props.updateEffects} checkIsValid={checkIsValid} />

                    <Grid cols={'auto'} style={{ gridTemplateRows: 'auto 0px', overflow: 'hidden', padding: '2px 2px 2px 1px' }}>
                        <GridCell>
                            <div className={'right-panel-wrapper tiny-scrollbar shadow-box scrollable max-height white-bg'}>
                                <Steps>
                                    <Grid cols="auto 1fr" gap="10px">
                                        {filteredSteps.map((step, i) => <React.Fragment key={`step_${i}`}>{step.content}</React.Fragment>)}
                                    </Grid>
                                </Steps>
                            </div>
                        </GridCell>

                        <GridCell>
                            {(activeView === ACTIVE_VIEW_SHAPE_SELECTION && !form.is_keep_size) &&
                                <Div borderTop="1px solid #ccc" width={'100%'} position={'relative'} top={'-40px'} background={"#ffffffc0"} overflow={'hidden'}>
                                    <Grid cols="1fr auto" align="center" valign="center">
                                        <Button onClick={(e) => this.handleAddShape()} style={{ display: "block", width: "100%" }} simple={true} size="big" icon="plus-radix">
                                            {trans("add_shape_button")}
                                        </Button>
                                        {/* FIE-792 */}
                                        {/* {selectedLayers.length > 0 && activeGroupId === null &&
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    cursor: 'pointer',
                                                    right: 0,
                                                    top: 10,
                                                    zIndex: 9999,
                                                    width: '80px',
                                                    height: '80px',
                                                }}
                                                title={trans('create_layer_group')}
                                                onClick={() => createGroupFromSelected()}
                                            ><Icon type={'object-group'} color={'#009ba9'} size={20} /></div>
                                        } */}
                                    </Grid>
                                </Div>
                            }

                        </GridCell>
                    </Grid>
                </PanelGridCell>
            </>
        )
    }
}

const Steps = css("div")({
    padding: "10px",
    ".step": {
        fontSize: ".9em",
        fontWeight: "bold",
        background: "#009BA9",
        color: "white",
        margin: "-10px",
        padding: "10px",
        marginBottom: "0",
    },
    ".title": {
        fontSize: "0.9em",
        background: "#009BA9",
        color: "white",
        margin: "-10px",

        padding: "10px",
        marginBottom: "0",
    },
    ".content": {
        paddingBottom: "20px",
        paddingTop: "10px",
    }
})

const TabsGridCell = css(GridCell)({
    overflow: 'hidden',
    maxHeight: 'calc(100vh - 90px)',
    ' .muk-gridcell': {
        width: '39px',
        marginLeft: '2px',
    },
})

const PanelGridCell = css(GridCell)({
    alignContent: 'start',
    ' .muk-form-group': {
        marginBottom: '0 !important',
        padding: '0 !important',
    },
    ' .padding': {
        padding: '10px',
        background: '#fff',
        zIndex: 99,
        ' .muk-gridcell': {
            alignSelf: 'center',
        },
    },
    ' table': {
        marginBottom: 0,
    },
    ' .right-panel-wrapper': {
        height: 'calc(100vh - 160px)',
        position: "relative",
        alignContent: 'space-between',
    },
    ' .scrollable': {
        overflowY: 'auto',
    },
    ' .white-bg': {
        background: '#fff',
    },
    ' .shape-name': {
        padding: 0,
        maxWidth: '190px',
    },
    '@media screen and (max-width: 1200px)': {
        ' .shapes-list-tr td': {
            padding: '2px 0px',
        },
    },

})


function mapStateToProps(state) {
    return {
        form: selectFormValues(state, getFormName(state.isAlt)),
        isAlt: state.isAlt,
        editMode: state.editMode,
        project: state.project,
        activeGroupId: state.activeGroupId,
        activeShapeId: state.activeShapeId,
        undoRedoHistory: state.undoRedoHistory,
        activeView: state.activeView,
        selectedLayers: state.selectedLayers,
        gradients: state.gradients,
        randomProduct: state.randomProduct,
        imagickFonts: state.imagickFonts,
        shapeSets: state.shapeSets,

    }
}

export default connect(mapStateToProps, {
    change,
    setActiveShapeId,
    setActiveGroupId,
    setActiveView,
    setEditMode,
    setShapeSetsToStore,
    selectLayers,
    initForm,
    undoHistory,
    redoHistory,
    createToast,
})(RightPanel)
